export const HIGHLIGHTS_ID_PREFIX = 'highlight-';

// The prefixes of the section items ids
// Used to determine the type of the section item
export const HASHTAG_ID_TYPE_PREFIX = 'hashtag-';
export const SOURCES_TYPE_ID_TYPE_PREFIX = 'sources-by-type-';
export const DAILY_PICKS_ID = 'daily-picks';
